export default __webpack_public_path__ + "static/media/AutoJoinInFlood.b20371f3.svg";